// Material Dashboard 2 PRO React examples
import { useNavigate, useParams } from "react-router-dom";

import CrudService from "services/cruds-service";
import { useEffect, useState } from "react";
import { setDarkMode } from "context";
import { useMaterialUIController } from "context";
import PublicLevelMonitor from "./levelMonitor";
import PublicAssetTracker from "./AssetTracker";
import { setLayout } from "context";
import { toast } from "react-toastify";
import Loading from "examples/Loading";
import { InfoPage } from "error";
import PublicGateway from "../view-device/holykel-device/PublicGateway";

// Define constants for device type IDs to improve readability and maintainability
const DEVICE_TYPE_HOLYKEL = 9;
const DEVICE_TYPE_LEVEL_MONITOR = 4;

const PublicViewDevice = () => {
  const { id } = useParams();
  const [, dispatch] = useMaterialUIController();
  const navigate = useNavigate();
  const [deviceProfile, setDeviceProfile] = useState(null)
  const [deviceId, setDeviceId] = useState(null)
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLayout(dispatch, "page");
    if (!id) {
      setLoading(false);
      return
    };
    (async () => {
      try {
        setDarkMode(dispatch, true)
        let resp = await CrudService.checkPublicShareDevice(id);
        if (!resp.success) {
          navigate('/not-found')
          return
        }
        setDeviceId(resp.device_id)
        let response = await CrudService.checkDeviceType(resp.device_id)
        if (response && response?.data) {
          setDeviceProfile(response.data)
        } else {
          // Handle cases where the response is valid but doesn't contain the expected data
          console.warn("Device profile not found or unexpected response structure for ID:", id);
          setDeviceProfile(null);
          toast.info("Device profile could not be loaded.");
        }

      } catch (err) {
        console.error("Failed to fetch device profile:", err);
        setError(err); // Store the error object

        // Check for specific error status and provide user feedback
        if (err.status === 400) {
          toast.error("Device not found or access denied. Redirecting...");
          navigate("/user-profile");
        } else {
          toast.error("An unexpected error occurred while fetching device details.");
        }
      } finally {
        setLoading(false);
      }
    })();
  }, [id]);

  // Helper function to render the correct device component based on its type
  const renderDeviceComponent = () => {
    if (!deviceProfile) {
      return null; // Should ideally be caught by loading/error states, but good for safety
    }
    switch (deviceProfile.device_type_id) {
      case DEVICE_TYPE_HOLYKEL:
        let channel_list = deviceProfile?.channels_list ?? []
        return <PublicGateway deviceId={deviceId} channels={channel_list} default_channel={channel_list.length > 0 ? channel_list[0].channel_number : 0} />;
      case DEVICE_TYPE_LEVEL_MONITOR:
        return <PublicLevelMonitor deviceId={deviceId} />;
      default:
        // Default to AssetTracker for any other device_type_id
        return <PublicAssetTracker deviceId={deviceId} />
    }
  };

  if (loading) {
    return <><Loading transparent={true} /></>; // Simple loading indicator
  }

  // If an error occurred and it wasn't a 400 (which triggers navigation), display a generic error
  if (error && error.status !== 400) {
    return <InfoPage message={'Error: Failed to load device details. Please try again'} />;
    // return <div> <h1> Error: Failed to load device details. Please try again.</h1></div>;
  }

  // If not loading, no error, but deviceProfile is still null, it means no device was found
  if (!deviceProfile) {
    return <InfoPage message={'No device found for the given ID'} />;
    // return <div>No device found for the given ID.</div>;
  }

  return (
    <>
      {renderDeviceComponent()}
    </>
  );
};

export default PublicViewDevice;
